import {
  SESSION_SCHEMA_VERSION,
  SESSION_STALE_AFTER_MS,
  SESSION_STORAGE_KEY,
  type SessionState,
} from "./types";

// Persisted in localStorage so the last conversation survives a browser/tab
// close. We keep only the single last conversation (one key). The conversation
// never leaves the device — nothing is stored server-side.
export function loadSession(): SessionState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(SESSION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SessionState;
    if (!parsed?.sessionId || !parsed?.startedAt) return null;
    if (parsed.v !== SESSION_SCHEMA_VERSION) {
      window.localStorage.removeItem(SESSION_STORAGE_KEY);
      return null;
    }
    if (Date.now() - parsed.startedAt > SESSION_STALE_AFTER_MS) {
      window.localStorage.removeItem(SESSION_STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveSession(state: SessionState) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(state));
  } catch {
    // ignore quota errors
  }
}

export function clearSession() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(SESSION_STORAGE_KEY);
}

export function newSessionId() {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}
